module["exports"] = ["stadt", "dorf", "land", "scheid", "burg"];